var utils = require('../../utils')

export default {
  name: 'doctor-edit',
  data: function () {
    return {
      clinicId: '',
      clinicName: '',
      acClinicName: '',
      doctorName: '',
      doctorFurigana: '',
      doctorTel: '',
      doctorMail: '',
      isNewDoctor: false,
      utils: utils,
      changeDate: '',
      searchCallbackFlag: false,
      nsDoctorCode: '',
      nsMedicalInstitutionReceptionCode: '',
      nsClinicalDepartmentCode: '',
      isNsipsFlag: false,
    }
  },
  beforeRouteLeave (to, from, next) {
    utils.autocompleteEventRemove({$: $, elem:'#clinic_name_autocomplete'}) // オートコンプリートイベント削除
    next()
  },
  created: function () {
    // this.$store.dispatch('SHOP_SEARCH')
    this.$store.dispatch('SHOP_SEARCH', {data: {all_get: true}, 'allShopName': this._self.$t('AllShopName'), callback: () => {}})

    if (this.$store.getters.canManage) {
      this.shopId = this.$store.getters.currentShopId
    }
    this.isNewDoctor = utils.isBlank(this.$route.params.doctorHisId)
    this.clearSearch()
    if (!this.isNewDoctor) {
      this.search()
    } else {
      // 新規作成
      if (utils.isPresent(this.$route.params.clinicId)) {
        // クリニック指定
        var self = this
        var callback = function () {
          if (self.clinic !== null && self.clinic.length > 0) {
            self.clinicId = self.clinic[0].id
            self.clinicName = self.clinic[0].attributes['clinic-name']
            self.acClinicName = self.clinic[0].attributes['clinic-name']
          }
          self.searchCallbackFlag = true
        }
        this.$store.dispatch('CLINIC_SEARCH', {
          data: {clinic_id: this.$route.params.clinicId},
          loadparams:       true,
          autocomplete:     false,
          callback:         callback
        })
      } else {
        this.searchCallbackFlag = true
      }
    }
    if(this.$router.currentRoute.query.nsips == 'doctor'){
      this.isNsipsFlag = true
      if (utils.isPresent(this.$router.currentRoute.query.doctor_code)) {
        var self = this
        var callback = function () {
          if(self.nsDoctor.prescription != null){
            self.doctorName = self.nsDoctor.prescription['doctor_kanji_full_name']
            self.nsDoctorCode = self.nsDoctor.prescription['doctor_code']
            self.nsMedicalInstitutionReceptionCode = self.nsDoctor.prescription['medical_institution_reception_code']
            self.nsClinicalDepartmentCode = self.nsDoctor.prescription['clinical_department_code']
          }
          if(self.nsDoctor.clinic != null){
            self.clinicName = self.nsDoctor.clinic['clinic_name']
            self.acClinicName = self.nsDoctor.clinic['clinic_name']
            self.clinicId = self.nsDoctor.clinic['clinic_id']
          }
        }
        this.$store.dispatch('NS_DOCTOR_SEARCH', {
          data: { ns_doctor: this.$router.currentRoute.query.doctor_code, shop_id: this.$router.currentRoute.query.shop_id, medical_institution_reception_code: this.$router.currentRoute.query.medical_institution_reception_code, clinical_department_code: this.$router.currentRoute.query.clinical_department_code },
          callback: callback
        })
      }
    }

    // オートコンプリートイベント
    utils.autocompleteEvent({
      $:                  $,
      elem:               '#clinic_name_autocomplete',
      search:             this.search,
      searchParams:       false,
      searchAutocomplete: this.getClinics,
      setSearchData:      this.setSearchClinic,
      clear:              this.clearClinics,
    })
  },
  mounted () {
    if (!this.isNewDoctor) {
      // ヘルプボタン表示
      utils.helpModalShow()
    }
  },
  computed: {
    doctor() {
      return this.$store.getters.doctor
    },
    clinic() {
      return this.$store.getters.clinics
    },
    clinics() {
      return this.$store.getters.clinicsAutocomplete
    },
    /** 必須チェック */
    required: function() {
      return {
        clinicId:              utils.isBlank(this.clinicId),              // 医療機関
        doctorName:            utils.isBlank(this.doctorName),            // 医師
        doctorFurigana_format: !utils.isHiragana(this.doctorFurigana),    // ひらがな
        doctorTel_format:      !utils.isPhone(this.doctorTel),            // 電話番号
        doctorMail_format:     !utils.isEmail(this.doctorMail),           // メール
        changeDate_format:     !utils.isWareki(this.$t, this.changeDate), // 日付
      }
    },
    /** 必須チェック全てOK */
    isRequiredComplete () {
      var req  = this.required
      var result = true
      // 必須
      for (var key in req) {
        if (req[key]) {
          result = false
          break
        }
      }
      return result
    },
    loading() {
      return this.$store.getters.apiLoading
    },
    notify() {
      return this.$store.getters.doctorNotify
    },
    nsDoctor() {
      return this.$store.getters.ns_doctor
    }
  },
  methods: {
    search: function () {
      var data = {
        doctor_history_id: this.$route.params.doctorHisId
      }
      var self = this
      var callback = function () {
        if (utils.isBlank(self.doctor)) {
          self.goPrev()
          return
        }
        self.clinicId = self.doctor.attributes['clinic-id']
        self.clinicName = self.doctor.attributes['clinic-name']
        self.acClinicName = self.doctor.attributes['clinic-name']
        self.doctorName = self.doctor.attributes['doctor-name']
        self.doctorFurigana = self.doctor.attributes['doctor-name-furigana']
        self.doctorTel = self.doctor.attributes['mobile']
        self.doctorMail = self.doctor.attributes['email']
        // self.doctorId = self.doctor.attributes['doctor-id']
        self.changeDate = ''
        self.searchCallbackFlag = true
      }
      this.searchCallbackFlag = false
      this.$store.dispatch('CLINIC_AUTOCOMPLETE_CLEAR', 0)
      this.$store.dispatch('DOCTOR_SEARCH_HISTORY', {data: data, callback: callback})
    },
    goFacilities: function () {
      this.$router.push({ path: '/facilities', query: { type: this.$router.currentRoute.query.type } })
    },
    goFacilityPersons: function () {
      this.$router.push({ path: '/facility_persons', query: { type: this.$router.currentRoute.query.type } })
    },
    goCareOffices: function () {
      this.$router.push({ path: '/care_offices', query: { type: this.$router.currentRoute.query.type } })
    },
    goClinics: function () {
      this.$router.push({ path: '/clinics', query: { type: this.$router.currentRoute.query.type } })
    },
    goDoctors: function () {
      this.$router.push({ path: '/doctors', query:{type: this.$router.currentRoute.query.type} })
    },
    goCareManagers: function () {
      this.$router.push({ path: '/care_managers', query: { type: this.$router.currentRoute.query.type } })
    },
    onClickSave: function () {
      if (!this.isRequiredComplete) {
        return
      }
      if (utils.isBlank(this.doctorTel)) {
        this.save()
        return
      }
      this.$store.dispatch('DOCTOR_DUPLICATE_CHECK', {
        data: {
          doctor_id: this.$route.params.doctorId,
          mobile: this.doctorTel
        },
        callback: (result) => {
          if (result) {
            var button = document.getElementById('duplicate_tel_modal_button')
            button.click()
          } else {
            this.save()
          }
        }
      })
    },
    save: function(){
      var doctorId = null
      if (utils.isPresent(this.$route.params.doctorId)) {
        doctorId = this.$route.params.doctorId
      }
      var data = {
        doctor_history_id: this.$route.params.doctorHisId,
        doctor_id: doctorId,
        clinic_id: this.clinicId,
        doctor_name: this.doctorName,
        doctor_name_furigana: this.doctorFurigana,
        mobile: this.doctorTel,
        email: this.doctorMail,
        change_date: this.isNewDoctor ? "" : utils.wareki2Seireki(this.$t, this.changeDate, 'y-m-d'),
        doctor_code: this.nsDoctorCode,
        medical_institution_reception_code: this.nsMedicalInstitutionReceptionCode,
        clinical_department_code: this.nsClinicalDepartmentCode,
        shop_id: this.shopId
      }
      var self = this
      var callback = function () {
        self.goPrev()
      }
      this.$store.dispatch('DOCTOR_EDIT', {data: data, callback: callback})
    },

    /** クリニック */
    getClinics: function () {
      var name = this.acClinicName
      if (name === this.$t('none_list.name')) {
        name = ''
      }
      this.$store.dispatch('CLINIC_SEARCH', {
        data: {
          'clinic_name': name,
          'all_get': true,
        },
        loadparams: false,
        autocomplete: true,
        noneList: {id: this.$t('none_list.id'), name: this.$t('none_list.name')}
      })
    },
    clearClinics: function () {
      if (this.acClinicName !== this.clinicName) {
        this.acClinicName = this.clinicName
        this.$store.dispatch('DOCTOR_MSG_ALERT', { message_i18n: 'messages.select_list_item', danger: true })
      }
      // オートコンプリートクリア
      this.$store.dispatch('CLINIC_AUTOCOMPLETE_CLEAR')
    },
    setSearchClinic: function (id, name) {
      var nm = this.trim(name)
      this.clinicId = id
      this.clinicName = nm
      this.acClinicName = nm
      // オートコンプリートクリア
      this.$store.dispatch('CLINIC_AUTOCOMPLETE_CLEAR')
    },
    goPrev: function () {
      if (this.isNewDoctor) {
        this.goDoctorList()
      } else {
        var query = {type: this.$router.currentRoute.query.type}
        if (utils.isBlank(this.$route.params.clinicId)) {
          this.$router.push({ path: '/doctors/' + this.$route.params.doctorId, query: query })
        } else {
          // クリニック指定
          this.$router.push({ path: '/doctors/' + this.$route.params.doctorId + '/' + this.$route.params.clinicId, query: query })
        }
      }
    },
    goDoctorList: function () {
      var query = { type: this.$router.currentRoute.query.type, keep: 'true'}
      if(this.$router.currentRoute.query.nsips == 'doctor'){
        this.$router.push({ path: '/nsips/doctors/list'})
      } else if (utils.isBlank(this.$route.params.clinicId)) {
        this.$router.push({ path: '/doctors', query: query })
      } else {
        // クリニック指定
        this.$router.push({ path: '/doctors/list/' + this.$route.params.clinicId, query: query })
      }
    },
    getReferenceDate: function () {
      if (this.doctor != null) {
        var start = this.utils.sereki2Wareki(this.$t, new Date(this.doctor.attributes['start-date']))
        var end = new Date(this.doctor.attributes['end-date'])
        if (end.getFullYear() == this.$t('history.max_year')) {
          end = this.$t('history.max_display')
        } else {
          end = this.utils.sereki2Wareki(this.$t, end)
        }
        return start + this.$t('history.delimiter') + end
      } else {
        return ''
      }
    },
    clearSearch: function () {
      this.$store.dispatch('DOCTOR_EDIT_CLEAR')
    },
    trim: function (name) {
      if (!name) return ''
      if (name.trim() == this.$t('none_list.name')) return ''
      return name.trim()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/doctor-edit.js